import { extractDisplayNames, generateUniqueName } from '../helpers';
import { NameInputModal, NameInputModalProps } from './NameInputModal';

export interface DirectoryNameModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (directoryName: string) => void;
  existingDirectories: string[];
  title?: string;
  confirmButtonText?: string;
}

const generateUniqueDirectoryName = (existingDirectories: string[]): string => {
  const baseName = 'Untitled_directory';
  const existingDirectoryNames = extractDisplayNames(existingDirectories);
  return generateUniqueName(baseName, existingDirectoryNames);
};

export const DirectoryNameModal = (props: DirectoryNameModalProps) => {
  const {
    isOpen,
    onClose,
    onConfirm,
    existingDirectories,
    title = 'New directory',
    confirmButtonText = 'Create',
  } = props;

  const nameInputProps: NameInputModalProps = {
    isOpen,
    onClose,
    onConfirm,
    title,
    confirmButtonText,
    existingNames: existingDirectories,
    generateUniqueName: generateUniqueDirectoryName,
  };

  return <NameInputModal {...nameInputProps} />;
};
